import type { User } from "firebase/auth"

import type { Authentication } from "@/lib/authentication"

export const updatePatientOnServer = async ({
  updates,
  user,
}: {
  updates: Authentication.UpdateData
  user: User
}): Promise<Response> => {
  return fetch(`/api/update-patient`, {
    body: JSON.stringify({
      auth_token: await user.getIdToken(),
      email_address: updates.email,
      first_name: updates.firstName,
      last_name: updates.lastName,
      marketing_email: updates.newsletter,
      phone_number: updates.phoneNumber,
    }),
    headers: { "Content-Type": `application/json` },
    method: `POST`,
  })
}
